"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Channels = function Channels(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    d: "M13.333 11.545h2l-2-1.909v1.91zm.472-2.359l2 1.91c.125.12.195.28.195.45v3.818c0 .35-.299.636-.667.636h-4.666c-.368 0-.667-.285-.667-.636V9.636c0-.35.299-.636.667-.636h2.666c.177 0 .347.067.472.186zM8 12a1 1 0 0 1-1.004 1H.666A.667.667 0 0 1 0 12.333V1.01C0 .44.448 0 1 0c.556 0 1 .448 1 1v1h5.01A1 1 0 0 1 8 3c0 .556-.444 1-.99 1H2v7h5.01A1 1 0 0 1 8 12zm5.333-9.455h2l-2-1.909v1.91zm.472-2.359l2 1.91c.125.12.195.28.195.45v3.818c0 .35-.299.636-.667.636h-4.666C10.299 7 10 6.715 10 6.364V.636c0-.35.299-.636.667-.636h2.666c.177 0 .347.067.472.186z",
    className: "fill"
  }));
};

exports["default"] = Channels;